<template>
<div id="page-carga_ds" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Cargar ZIP Datastage" class="elevation-1 px-5 py-3" >
                   
                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>   
                                        <p class="text-justify" v-show="mostrarEncabezados==true" >
                                            <v-icon color="indigo" >info</v-icon>                                            
                                            Verifique que los archivos .asc contengan los encabezados correctos: 
                                                Ver <v-btn small outlined text @click="modalEncabezados=true" >Encabezados de Archivos</v-btn>
                                        </p>                                     
                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" multiple style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                            <br><p>&nbsp;</p>
                            <div v-show="errores.length>0">
                                <p class="text-justify" style="color:red;font-weight:bold;" >                                    
                                    Los siguientes archivos no se cargaron debido a que se encontraron errores. Corríja lor archivos y vuelva a cargarlos:
                                </p>                                     
                                <div v-for="(error, index) in errores" :key="index">
                                    <p v-html="error"></p>
                                </div>
                            </div>
                            <div v-show="correctos.length>0">
                                <p class="text-justify" style="color:green;font-weight:bold;" >  
                                    Archivos válidos que se están procesando. Recibirá notificaciones cuando terminen de cargarse:
                                </p>                                     
                                <div v-for="(nombre, index) in correctos" :key="index">
                                    <strong>{{nombre}}</strong>
                                </div>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn@click.native="modal=false; reset();" >
                                <v-icon>cancel</v-icon> Cancelar
                            </v-btn>                            
                        </v-card-actions>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

        <!-- MODAL -->
        <v-dialog v-model="modalEncabezados" max-width="80%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modalEncabezados = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Encabezados para cada archivo</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <div class="archivoNegrita" >_501.asc</div>
                    <span id ="id501" >Patente|Pedimento|SeccionAduanera|TipoOperacion|ClaveDocumento|SeccionAduaneraEntrada|CurpContribuyente|Rfc|CurpAgenteA|TipoCambio|TotalFletes|TotalSeguros|TotalEmbalajes|TotalIncrementables|TotalDeducibles|PesoBrutoMercancia|MedioTransporteSalida|MedioTransporteArribo|MedioTransporteEntrada_Salida|DestinoMercancia|NombreContribuyente|CalleContribuyente|NumInteriorContribuyente|NumExteriorContribuyente|CPContribuyente|MunicipioContribuyente|EntidadFedContribuyente|PaisContribuyente|TipoPedimento|FechaRecepcionPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id501')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>
                    
                    <div class="archivoNegrita" >_502.asc</div>
                    <span id="id502" >Patente|Pedimento|SeccionAduanera|RfcTransportista|CurpTransportista|NombreTransportista|PaisTransporte|IdentificadorTransporte|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id502')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_503.asc</div>
                    <span id="id503" >Patente|Pedimento|SeccionAduanera|NumeroGuia|TipoGuia|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id503')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_504.asc</div>
                    <span id="id504" >Patente|Pedimento|SeccionAduanera|NumContenedor|TipoContenedor|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id504')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_505.asc</div>
                    <span id="id505" >Patente|Pedimento|SeccionAduanera|FechaFacturacion|NumeroFactura|TerminoFacturacion|MonedaFacturacion|ValorDolares|ValorMonedaExtranjera|PaisFacturacion|EntidadFedFacturacion|IndentFiscalProveedor|ProveedorMercancia|CalleProveedor|NumInteriorProveedor|NumExteriorProveedor|CpProveedor|MunicipioProveedor|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id505')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_506.asc</div>
                    <span id="id506" >Patente|Pedimento|SeccionAduanera|TipoFecha|FechaOperacion|FechaValidacionPagoR</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id506')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_507.asc</div>
                    <span id="id507" >Patente|Pedimento|SeccionAduanera|ClaveCaso|IdentificadorCaso|TipoPedimento|ComplementoCaso|FechaValidacionPagoR</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id507')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_508.asc</div>
                    <span id="id508" >Patente|Pedimento|SeccionAduanera|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|TipoCuenta|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidades|TitulosAsignados|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id508')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_509.asc</div>
                    <span id="id509" >Patente|Pedimento|SeccionAduanera|ClaveContribucion|TasaContribucion|TipoTasa|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id509')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_510.asc</div>
                    <span id="id510" >Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id510')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_511.asc</div>
                    <span id="id511" >Patente|Pedimento|SeccionAduanera|SecuenciaObservacion|Observaciones|TipoPedimento|FechaValidacionPagoR</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id511')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_512.asc</div>
                    <span id="id512" >Patente|Pedimento|SeccionAduanera|PatenteAduanalOrig|PedimentoOriginal|SeccionAduaneraDespOrig|DocumentoOriginal|FechaOperacionOrig|FraccionOriginal|UnidadMedida|MercanciaDescargada|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id512')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_520.asc</div>
                    <span id="id520" >Patente|Pedimento|SeccionAduanera|IndentFiscalDestinatario|NombreDestinatarioMercancia|CalleDestinatario|NumInteriorDestinatario|NumExteriorDestinatario|CpDestinatario|MunicpioDestinatario|PaisDestinatario|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id520')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_551.asc</div>
                    <span id="id551" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SubdivisionFraccion|DescripcionMercancia|PrecioUnitario|ValorAduana|ValorComercial|ValorDolares|CantidadUMComercial|UnidadMedidaComercial|CantidadUMTarifa|UnidadMedidaTarifa|ValorAgregado|ClaveVinculacion|MetodoValorizacion|CodigoMercanciaProducto|MarcaMercanciaProducto|ModeloMercanciaProducto|PaisOrigenDestino|PaisCompradorVendedor|EntidadFedOrigen|EntidadFedDestino|EntidadFedComprador|EntidadFedVendedor|TipoOperacion|ClaveDocumento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id551')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_552.asc</div>
                    <span id="id552" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|VinNumeroSerie|KilometrajeVehiculo|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id552')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_553.asc</div>
                    <span id="id553" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClavePermiso|FirmaDescargo|NumeroPermiso|ValorComercialDolares|CantidadMUMTarifa|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id553')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_554.asc</div>
                    <span id="id554" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveCaso|IdentificadorCaso|ComplementoCaso|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id554')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_555.asc</div>
                    <span id="id555" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidadesMedida|TitulosAsignados|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id555')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_556.asc</div>
                    <span id="id556" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|TasaContribucion|TipoTasa|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id556')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_557.asc</div>
                    <span id="id557" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|FormaPago|ImportePago|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id557')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_558.asc</div>
                    <span id="id558" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SecuenciaObservacion|Observaciones|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id558')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_701.asc</div>
                    <span id="id701" >Patente|Pedimento|SeccionAduanera|ClaveDocumento|FechaPago|PedimentoAnterior|PatenteAnterior|SeccionAduaneraAnterior|DocumentoAnterior|FechaOperacionAnterior|PedimentoOriginal|PatenteAduanalOrig|SeccionAduaneraDespOrig|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id701')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_702.asc</div>
                    <span id="id702" >Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id702')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_Inci.asc</div>
                    <span id="idInci" >Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaInicioReconocimiento|HoraInicioReconocimiento|FechaFinReconocimiento|HoraFinReconocimiento|Fraccion|SecuenciaFraccion|ClaveDocumento|TipoOperacion|GradoIncidencia|FechaSeleccion</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('idInci')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_Resumen.asc</div>
                    <span id="idResumen" >Folio|RFCoPatenteAduanal|Fecha_Inicial|Fecha_Final|Fecha_Ejecucion|Total_Fracciones|Total_Contribuciones</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('idResumen')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_Sel.asc</div>
                    <span id="idSel" >Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaSeleccion|HoraSeleccion|SemaforoFiscal|ClaveDocumento|TipoOperacion</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('idSel')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>
                    

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modalEncabezados = false" >
                        <v-icon>cancel</v-icon>Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'

export default {
    created: function () {
        this.get_clientes_grupo();
        
    },
    data() {
        return {
            correctos:[],
            rfcs:[],
            rfcs_grupo:[],
            errores: [],
            fab: false,
            mostrarEncabezados: false,
            modalEncabezados: false,
            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Datastage",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Carga ZIP Datastage",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',
            archivo_original: "",

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {
        get_clientes_grupo: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = {
                usuario: this.$local_storage.get("id_usuario"),                
               // usuario:14,
                sistema: this.$sistema,
            };

            axios.post(this.$hostname + "usuarios/get_clientes_grupo/", data)
                .then(res => {
                if (res.data != undefined) {
                    this.rfcs= res.data;
                    var self = this;
                    this.rfcs.forEach(e => {
                        self.rfcs_grupo.push(e.id);
                    });                    
                } else {
                    this.rfcs = [];
                    this.rfcs_grupo = [];
                }
                })
                .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los RFC del Grupo.",
                    footer: ""
                });
                console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        copyText: function(id) {            
            var el = document.getElementById(id);
            var body = document.body, range, sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(el);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(el);
                    sel.addRange(range);
                }
                document.execCommand("copy");

            } else if (body.createTextRange) {
                range = body.createTextRange();
                range.moveToElementText(el);
                range.select();
                range.execCommand("Copy");
            }                                  
        },
        getCamposLayout: function () {
            axios
                .get(this.$hostname + "catalogos/templates/campos_doc/ ")
                .then(response => {
                    this.camposLayout = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                });
        },
        pickFile() {
            this.$refs.file_input.click();
        },

        onFilePicked: async function (e) {
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var name_file = "";
                this.errores = [];
                this.correctos = [];
                const files = e.target.files; 
                
                var numero_files = 0;
                for(var k in files){         
                    if (files[k] !== undefined && files[k].name !== undefined && files[k].size!== undefined && files[k].type!== undefined) {
                        numero_files+=1;
                    }
                } 

                if(numero_files > 20){
                    this.$swal({    
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Se permite un máximo de 20 archivos. Favor de verificar.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                    this.reset();
                } else {
                   for(var k in files){         
                        var datastage = ["_501", "_502", "_503", "_504", "_505", "_506", "_507", "_508", "_509", "_510", "_511", "_512", "_520", "_551", "_552", "_553", "_554", "_555", "_556", "_557", "_558", "_701", "_702", "_Inci", "_Resumen", "_Sel"];                               
                        if (files[k] !== undefined && files[k].name !== undefined && files[k].size!== undefined && files[k].type!== undefined) {
                            name_file = files[k].name;
                            var size_file = files[k].size;
                            var type_file = files[k].type;
                            var archivo_original = files[k];
                            if (name_file.lastIndexOf('.') <= 0) {
                                continue;
                            }
                            const fr = new FileReader();
                            fr.readAsDataURL(files[k]);
                            await this.leerZip(fr, archivo_original, name_file, type_file);
                        }
                    }  
                }
                
                               
            } catch (error) {
                console.log(error);
                var error = "<strong>"+name_file+":</strong> Ocurrió un error al leer el archivo. Verifique que no esté dañado y sea un arhivo Zip correcto.";
                this.errores.push(error);
                this.reset();
            }

        },

        leerZip(fr, archivo_original, name_file, type_file){
            var datastage = ["_501", "_502", "_503", "_504", "_505", "_506", "_507", "_508", "_509", "_510", "_511", "_512", "_520", "_551", "_552", "_553", "_554", "_555", "_556", "_557", "_558", "_701", "_702", "_Inci", "_Resumen", "_Sel"];                               
            var new_zip = new JSZip();
            var tieneResumen = 0;
            var thisObj = this;

            fr.addEventListener('load', () => {
                var fileReaded = fr.result; // this is an image file that can be sent to server...          
                var n = fileReaded.search("base64,");
                //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
                if (n >= 0) {
                    fileReaded = fileReaded.substring(n + 7);
                }
                
                new_zip.loadAsync(fileReaded, {
                        base64: true
                    })
                    .then(function (zip) {
                        var folio = '';
                        var rfc = '';
                        var f_inicial = '';
                        var f_final = '';

                        zip.forEach(function (relativePath, file) {
                            if (relativePath.search("__MACOSX/") == -1) {
                                //Verificamos que tenga todos los archivos del datastage
                                for (var k in datastage) {
                                    if (relativePath.search(datastage[k]) != -1)
                                        datastage.splice(k, 1);
                                }
                            }
                        });

                        if (datastage.length > 0) {
                            var error = "<strong>"+name_file+":</strong> Faltan los archivos " + datastage.join(", ") + " en el ZIP. Favor de verificar.";
                            thisObj.errores.push(error);
                            thisObj.$root.$dialogLoader.hide();
                        } else {
                            //Recorremos cada archivo para verificar que tenga los encabezados correctos   
                            var patron= {};
                            patron["_501"]="Patente|Pedimento|SeccionAduanera|TipoOperacion|ClaveDocumento|SeccionAduaneraEntrada|CurpContribuyente|Rfc|CurpAgenteA|TipoCambio|TotalFletes|TotalSeguros|TotalEmbalajes|TotalIncrementables|TotalDeducibles|PesoBrutoMercancia|MedioTransporteSalida|MedioTransporteArribo|MedioTransporteEntrada_Salida|DestinoMercancia|NombreContribuyente|CalleContribuyente|NumInteriorContribuyente|NumExteriorContribuyente|CPContribuyente|MunicipioContribuyente|EntidadFedContribuyente|PaisContribuyente|TipoPedimento|FechaRecepcionPedimento|FechaPagoReal";
                            patron["_502"] = "Patente|Pedimento|SeccionAduanera|RfcTransportista|CurpTransportista|NombreTransportista|PaisTransporte|IdentificadorTransporte|FechaPagoReal";
                            patron["_503"] = "Patente|Pedimento|SeccionAduanera|NumeroGuia|TipoGuia|FechaPagoReal";
                            patron["_504"] = "Patente|Pedimento|SeccionAduanera|NumContenedor|TipoContenedor|FechaPagoReal";
                            patron["_505"] = "Patente|Pedimento|SeccionAduanera|FechaFacturacion|NumeroFactura|TerminoFacturacion|MonedaFacturacion|ValorDolares|ValorMonedaExtranjera|PaisFacturacion|EntidadFedFacturacion|IndentFiscalProveedor|ProveedorMercancia|CalleProveedor|NumInteriorProveedor|NumExteriorProveedor|CpProveedor|MunicipioProveedor|FechaPagoReal";
                            patron["_506"] = "Patente|Pedimento|SeccionAduanera|TipoFecha|FechaOperacion|FechaValidacionPagoR";
                            patron["_507"] = "Patente|Pedimento|SeccionAduanera|ClaveCaso|IdentificadorCaso|TipoPedimento|ComplementoCaso|FechaValidacionPagoR";
                            patron["_508"] = "Patente|Pedimento|SeccionAduanera|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|TipoCuenta|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidades|TitulosAsignados|FechaPagoReal";
                            patron["_509"] = "Patente|Pedimento|SeccionAduanera|ClaveContribucion|TasaContribucion|TipoTasa|TipoPedimento|FechaPagoReal";
                            patron["_510"] = "Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal";
                            patron["_511"] = "Patente|Pedimento|SeccionAduanera|SecuenciaObservacion|Observaciones|TipoPedimento|FechaValidacionPagoR";
                            patron["_512"] = "Patente|Pedimento|SeccionAduanera|PatenteAduanalOrig|PedimentoOriginal|SeccionAduaneraDespOrig|DocumentoOriginal|FechaOperacionOrig|FraccionOriginal|UnidadMedida|MercanciaDescargada|TipoPedimento|FechaPagoReal";
                            patron["_520"] = "Patente|Pedimento|SeccionAduanera|IndentFiscalDestinatario|NombreDestinatarioMercancia|CalleDestinatario|NumInteriorDestinatario|NumExteriorDestinatario|CpDestinatario|MunicpioDestinatario|PaisDestinatario|FechaPagoReal";
                            patron["_551"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SubdivisionFraccion|DescripcionMercancia|PrecioUnitario|ValorAduana|ValorComercial|ValorDolares|CantidadUMComercial|UnidadMedidaComercial|CantidadUMTarifa|UnidadMedidaTarifa|ValorAgregado|ClaveVinculacion|MetodoValorizacion|CodigoMercanciaProducto|MarcaMercanciaProducto|ModeloMercanciaProducto|PaisOrigenDestino|PaisCompradorVendedor|EntidadFedOrigen|EntidadFedDestino|EntidadFedComprador|EntidadFedVendedor|TipoOperacion|ClaveDocumento|FechaPagoReal";
                            patron["_552"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|VinNumeroSerie|KilometrajeVehiculo|FechaPagoReal";
                            patron["_553"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClavePermiso|FirmaDescargo|NumeroPermiso|ValorComercialDolares|CantidadMUMTarifa|FechaPagoReal";
                            patron["_554"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveCaso|IdentificadorCaso|ComplementoCaso|FechaPagoReal";
                            patron["_555"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidadesMedida|TitulosAsignados|FechaPagoReal";
                            patron["_556"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|TasaContribucion|TipoTasa|FechaPagoReal";
                            patron["_557"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|FormaPago|ImportePago|FechaPagoReal";
                            patron["_558"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SecuenciaObservacion|Observaciones|FechaPagoReal";
                            patron["_701"] = "Patente|Pedimento|SeccionAduanera|ClaveDocumento|FechaPago|PedimentoAnterior|PatenteAnterior|SeccionAduaneraAnterior|DocumentoAnterior|FechaOperacionAnterior|PedimentoOriginal|PatenteAduanalOrig|SeccionAduaneraDespOrig|FechaPagoReal";
                            patron["_702"] = "Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal";
                            patron["_Inci"] = "Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaInicioReconocimiento|HoraInicioReconocimiento|FechaFinReconocimiento|HoraFinReconocimiento|Fraccion|SecuenciaFraccion|ClaveDocumento|TipoOperacion|GradoIncidencia|FechaSeleccion";
                            patron["_Resumen"] = "Folio|RFCoPatenteAduanal|Fecha_Inicial|Fecha_Final|Fecha_Ejecucion|Total_Fracciones|Total_Contribuciones";                                    
                            patron["_Sel"] = "Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaSeleccion|HoraSeleccion|SemaforoFiscal|ClaveDocumento|TipoOperacion";

                            var dataResumen = "";
                            var folio = "";
                            var rfc = "";
                            var f_inicial = "";
                            var f_final = "";
                            var incorrectos = [];
                            var totalLeidos = [];   
                            var datastage2 = ["_501", "_502", "_503", "_504", "_505", "_506", "_507", "_508", "_509", "_510", "_511", "_512", "_520", "_551", "_552", "_553", "_554", "_555", "_556", "_557", "_558", "_701", "_702", "_Inci", "_Resumen", "_Sel"];                                 
                            zip.forEach(function (relativePath, file) {                                            
                                if (relativePath.search("__MACOSX/") == -1){                                            
                                    file.async('text').then(async function (content) {                                                    
                                        if (relativePath.search(".asc") != -1) { 
                                            var splitRelative = relativePath.split("/");                                                    
                                            if(splitRelative.length>0){                                                        
                                                var nombreArchivo = splitRelative[splitRelative.length-1];
                                                for(var keyD in datastage2){                                                                                                               
                                                    if (nombreArchivo.search(datastage2[keyD]) != -1) { 
                                                        if (totalLeidos.findIndex(function(l){return l== datastage2[keyD]})== -1)
                                                            totalLeidos.push(datastage2[keyD]);                                                      
                                                        if (content.indexOf(patron[datastage2[keyD]]) == -1) incorrectos.push(nombreArchivo);                                                                
                                                        if (datastage2[keyD]=="_Resumen" && incorrectos.findIndex(function(i){return i==nombreArchivo}) == -1) {                                                                
                                                            dataResumen = content.split("|");
                                                            folio = dataResumen[6].replace("Total_Contribuciones", "").replace(" ", "").replace(/(\r\n|\n|\r)/gm, "");
                                                            rfc = dataResumen[7];
                                                            f_inicial = dataResumen[8];                                                            
                                                            f_final = dataResumen[9];                                                            
                                                        }
                                                    }    
                                                }
                                            }
                                            
                                        }                                              
                                        
                                        if (totalLeidos.length == 26){                                                       
                                            thisObj.$root.$dialogLoader.hide();                                         
                                            if (incorrectos.length > 0){
                                                var error2 = "<strong>"+name_file+":</strong> Encabezados incorrectos. Favor de verificar. "+"Incorrectos: "+incorrectos.join(", ");
                                                thisObj.errores.push(error2);
                                                thisObj.mostrarEncabezados = true;
                                                thisObj.$root.$dialogLoader.hide();
                                                
                                            } else {  
                                                if(thisObj.rfcs_grupo.includes(rfc)){
                                                    await thisObj.verificaResumen(folio, rfc, f_inicial, f_final, archivo_original, type_file, name_file);
                                                }  else {
                                                    var errorrfc = "<strong>"+name_file+":</strong> El RFC "+rfc+" no se encuentra en el grupo de clientes al que pertenece su usuario. Favor de verificar.";
                                                    thisObj.errores.push(errorrfc);
                                                }                                                
                                            }
                                            
                                        } 
                                    });
                                }  
                                
                                                                    
                            });
                            
                            
                            
                        }

                    });
            });
        },

        verificaResumen: function (folio, rfc, f_inicial, f_final, archivo_original, type_file, name_file) {
            var rfcActual = this.rfc_seleccionado;
            var usuario = this.$local_storage.get("id_usuario");
            var anio_inicial = f_inicial.substring(0, 4);
            var mes_inicial = f_inicial.substring(5, 7);
            var anio_final = f_final.substring(0, 4);
            var mes_final = f_final.substring(5, 7);
            
            if (f_inicial.length != 10 || f_final.length != 10) {
                var error2 = "<strong>"+name_file+":</strong> Las fechas del archivo resumen: " + f_inicial + " o " + f_final + " no tienen el formato AAAA-MM-DD.";
                this.errores.push(error2);                
                this.$root.$dialogLoader.hide();
            } else {

                    let datos = {
                        rfc: rfc,
                        size: this.size_file,
                        folio: folio,
                        usuario_id: usuario,
                        fecha_inicial: f_inicial,
                        fecha_final: f_final,
                        anio_inicial: anio_inicial,
                        mes_inicial: mes_inicial,
                        anio_final: anio_final,
                        mes_final: mes_final,
                    };

                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var thisObj = this;
                    axios.post(this.$hostname + "datastage/guardar_bitacora/", datos)
                        .then(response => {                                
                            thisObj.guardarZip(rfc, folio, f_inicial, f_final, archivo_original, name_file, type_file);                            
                        })
                        .catch(error => {
                            var mostrarNotificacion = 1;
                            var mensaje = 'Ocurrió un error al cargar el archivo ZIP';
                            var footer = '';
                            if (error.response != undefined && error.response.data != undefined) {
                                if (error.response.data.mensaje != undefined && error.response.data.mensaje == 'Periodo existente'){                                        
                                    mostrarNotificacion = 0;                                            
                                    thisObj.guardarZip(rfc, folio, f_inicial, f_final, archivo_original, name_file, type_file);                                                                    
                                } else if (error.response.data.mensaje != undefined) {
                                    footer = "<strong>"+name_file+":</strong> "+error.response.data.mensaje;
                                    thisObj.errores.push(footer);
                                    thisObj.$root.$dialogLoader.hide();
                                } else if (error.response.data != undefined) {
                                    for (var k in error.response.data) {
                                        footer += k + ": " + error.response.data[k][0];
                                    }
                                    thisObj.errores.push("<strong>"+name_file+":</strong> "+footer);
                                    thisObj.$root.$dialogLoader.hide();
                                }

                            }
                           
                        });
                                    
            } 

        },

        guardarZip: function(rfc, folio, f_inicial, f_final, archivo_original, name_file, type_file, intento=1){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var keyBucket = rfc.toString().trim().toUpperCase() + "/glosas/" + rfc.toString().trim().toUpperCase() + "-" + folio.toString().trim() + "_" + f_inicial.toString().trim() + "_" + f_final.toString().trim() + ".zip";
            var zipfilekey = rfc.toString().trim().toUpperCase() + "-" + folio.toString().trim() + "_" + f_inicial.toString().trim() + "_" + f_final.toString().trim() + ".zip";
            //console.log("Intento:",intento);
                    
            var datos = {
                key: keyBucket,
                bucket: "production.econnect.ds",
                type: type_file
            }
            var thisObj = this;
            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;                        
                        axios.put(urlput, archivo_original, {headers:{'Content-Type': type_file}})
                        .then((res) => {
                            let formData = {                                
                                key: keyBucket,
                                usuario: thisObj.$local_storage.get("id_usuario"),                                
                            };
                            axios.post(thisObj.$apiVucem + 'datastage/guardar_glosa/', formData)
                            .then((res) => {
                                thisObj.correctos.push(name_file);
                            }).catch((error) => {//ya que si el archivo es muy grande recibirá un timeOut, igualmente recibirá notificación al terminar de cargarse
                                thisObj.correctos.push(name_file);
                            }).then(() => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.reset();
                            });
                        }).catch((error)=>{
                            if(intento >= 3){
                                thisObj.$root.$dialogLoader.hide();
                                var msj = "<strong>"+name_file+":</strong> Ocurrió un error al cargar el archivo. Favor de intentar nuevamente.";
                                thisObj.errores.push(msj);                                
                                //SI NO SE PUDO CARGAR A S3, SE ELIMINA EL REGISTRO DE LA GLOSA                    
                                thisObj.eliminaBitacora(zipfilekey, name_file);
                                console.log(error);
                                thisObj.$root.$dialogLoader.hide();
                            } else {
                                thisObj.guardarZip(rfc, folio, f_inicial, f_final, archivo_original, name_file, type_file, intento+1)
                            }
                            
                        });
                        
                    } else {
                        if(intento >= 3){
                            thisObj.$root.$dialogLoader.hide();
                            var msj2 = "<strong>"+name_file+":</strong> Ocurrió un error al cargar el archivo. Favor de intentar nuevamente.";
                            thisObj.errores.push(msj2);
                            //SI NO SE PUDO CARGAR A S3, SE ELIMINA EL REGISTRO DE LA GLOSA                    
                            thisObj.eliminaBitacora(zipfilekey, name_file);
                            thisObj.$root.$dialogLoader.hide();
                        } else {
                            thisObj.guardarZip(rfc, folio, f_inicial, f_final, archivo_original, name_file, type_file, intento+1)
                        }                        
                    }
                })
                .catch((error) => {
                    if(intento >= 3){
                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        
                        var msje2 = "<strong>"+name_file+":</strong> "+mensaje;
                        thisObj.errores.push(msje2);
                        console.log(error);
                        //SI NO SE PUDO CARGAR A S3, SE ELIMINA EL REGISTRO DE LA GLOSA                    
                        thisObj.eliminaBitacora(zipfilekey, name_file);
                        thisObj.$root.$dialogLoader.hide();
                    } else {
                        thisObj.guardarZip(rfc, folio, f_inicial, f_final, archivo_original, name_file, type_file, intento+1)
                    }                    
                });

        },

        eliminaBitacora: function(zipfilekey, name_file){
            axios.post(this.$hostname + "datastage/eliminar_bitacora/", {
                "nombre_glosa": zipfilekey
            })
            .then(response => {}).catch((err) => {
                
            });
        },

        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
            this.archivo_original = '';
        },        
    }
};
</script>
<style scoped>
.archivoNegrita {
  color: black !important;
  font-weight: bold !important;
  font-size: 15px;
}
</style>